/** @format */
import { InfiniteQueryObserverBaseResult } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

export const useSearchResultsInfiniteScroll = ({
    showAll,
    hasNextPage,
    fetchNextPage,
}: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    showAll: boolean;
    hasNextPage?: boolean;
    fetchNextPage?: InfiniteQueryObserverBaseResult['fetchNextPage'];
}) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    const [ref, inView] = useInView({
        rootMargin: '100px',
    });

    useEffect(() => {
        if (inView) {
            if (!showAll || !hasNextPage) {
                return;
            }

            // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Legacy code: do not use as an example.
            fetchNextPage?.();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- Legacy code: do not use as an example.
    }, [inView]);

    return ref;
};
